import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"

import Text from "../s22_text"
import { addCookieData } from "../../helpers/handleCookies"

class PardotForm extends Component {
  state = {
    iFrameHeight: 900,
    utms: "",
  }

  componentDidMount() {
    this.utmHandler()
    this.getIframeHeight()
  }

  utmHandler = () => {
    const { webCampaign, webContent, webMedium, webTerm, partnerCode } =
      addCookieData()

    if (addCookieData()) {
      let utmFields = []

      partnerCode && utmFields.push(`utm_source=${partnerCode}`)
      webMedium && utmFields.push(`utm_medium=${webMedium}`)
      webCampaign && utmFields.push(`utm_campaign=${webCampaign}`)
      webContent && utmFields.push(`utm_content=${webContent}`)
      webTerm && utmFields.push(`utm_term=${webTerm}`)

      this.setState({ utms: utmFields.join("&").replace(/\s/g, "%20") })
    }
  }

  getIframeHeight = () => {
    const { formHeight } = this.props.blok
    const iframe = document.getElementById("pardot-form")
    if (iframe && iframe.contentWindow && !formHeight) {
      this.setState({
        iFrameHeight: iframe.contentWindow.document.body.scrollHeight,
      })
    } else if (formHeight) {
      this.setState({ iFrameHeight: formHeight })
    }
  }

  render() {
    const { blok } = this.props
    const { iFrameHeight, utms } = this.state

    return (
      <SbEditable content={blok}>
        {blok.formUrl && (
          <iframe
            id="pardot-form"
            src={`${blok.formUrl}${utms ? `?${utms}` : ""}`}
            style={{
              width: "100%",
              height: `${iFrameHeight}px`,
              border: "0",
            }}
            title="Pardot Form"
          ></iframe>
        )}
        {blok.thank_you_copy && blok.thank_you_copy.length > 0 && (
          <Text blok={blok.thank_you_copy[0]} />
        )}
      </SbEditable>
    )
  }
}

PardotForm.propTypes = {
  blok: PropTypes.shape({
    embed_code: PropTypes.string,
    thank_you_copy: PropTypes.arrayOf(
      PropTypes.shape({
        copy: PropTypes.string,
      })
    ),
  }).isRequired,
}

export default PardotForm
